import { useContext } from "react";
import DruidWebchatContext, { DruidWebchatContextType } from "../WebChatContext";


export function useSelectedLanguage() {
    const [druidWebChatState,] = useContext<DruidWebchatContextType>(DruidWebchatContext);
    return druidWebChatState.botLanguages.find(bl => bl.isSelected);
}

export function useBotLanguages() {
    const [druidWebChatState,] = useContext<DruidWebchatContextType>(DruidWebchatContext);
    return druidWebChatState.botLanguages;
}